import { render, staticRenderFns } from "./layItemWin2.vue?vue&type=template&id=548c7146&scoped=true&"
import script from "./layItemWin2.vue?vue&type=script&lang=js&"
export * from "./layItemWin2.vue?vue&type=script&lang=js&"
import style0 from "./layItemWin2.vue?vue&type=style&index=0&id=548c7146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548c7146",
  null
  
)

export default component.exports